<span class="cmdk-row__face">
  <span class="cmdk-row__avatar" aria-hidden="true" [imPersonColour]="item().title">{{ initials() }}</span>
  <im-call-presence-dot [personId]="item().id" />
</span>

<span class="cmdk-row__text">
  <span class="cmdk-row__title">{{ item().title }}</span>
  @if (item().subtitle) {
    <span class="cmdk-row__subtitle">{{ item().subtitle }}</span>
  }
</span>

@if (item().locationLabel; as where) {
  <span class="cmdk-row__where">{{ where }}</span>
}

@if (quickOpenKey(); as digit) {
  <paper-kbd class="cmdk-row__quick" [keys]="digit" [mod]="true" size="sm" />
}
